import { activateRouteModule } from './activate/activate.route';
import { confirmRouteModule } from './confirm/confirm.route';
import { errorRouteModule } from './error/error.route';
import { resetPasswordRouteModule } from './reset-password/reset-password.route';
import { uiRouterStateModule } from '../vendor/ui-router-module';
import { NETWORK_ERROR_CODES } from '../interceptors/auto-retry-interceptor/auto-retry-interceptor';

let _wasLoggedOut;

export function wasLoggedOut() {
  const regex = /^Q_LOGGED_OUT!/;
  if (_wasLoggedOut === undefined) {
    _wasLoggedOut = !!(window && regex.test(window.name));
    if (_wasLoggedOut) {
      window.name = window.name.replace(regex);
    }
  }
  return _wasLoggedOut;
}

export const sharedRouteConfigModule = angular
  .module('Q.routes.shared-config', [
    uiRouterStateModule,
    activateRouteModule,
    confirmRouteModule,
    errorRouteModule,
    resetPasswordRouteModule,
  ])
  .config(
    function (
      $locationProvider,
      $urlMatcherFactoryProvider,
      $anchorScrollProvider,
    ) {
      $locationProvider.html5Mode(true);

      // allow trailing slashes
      $urlMatcherFactoryProvider.strictMode(false);
      // always squash default params
      $urlMatcherFactoryProvider.defaultSquashPolicy(true);

      $urlMatcherFactoryProvider.type('ObjectId', {
        pattern: /[a-fA-F0-9]{24}/,
      });
      $urlMatcherFactoryProvider.type('assessmentResultIdList', {
        pattern: /[a-fA-F0-9]{24}|list/,
      });
      $urlMatcherFactoryProvider.type('ObjectOrQId', {
        pattern: /(?:[a-fA-F0-9]{24}|s_[a-zA-Z0-9-_=]{10,})/,
      });

      $anchorScrollProvider.disableAutoScrolling();
    },
  )

  .run(
    function ($rootScope, $state, $stateParams, $window, $timeout, $injector) {
      $rootScope.$state = $state;
      $rootScope.$stateParams = $stateParams;

      let stateLoaded = false;

      // Enforce scrolling back to the top if the state (not just the parameters) changes.
      $rootScope.$on(
        '$stateChangeSuccess',
        function (event, toState, toParams, fromState /*, fromParams*/) {
          stateLoaded = true;
          if (toState.name !== fromState.name) {
            $window.scrollTo(0, 0);
          }
        },
      );

      const _getService = (svc) => $injector.has(svc) && $injector.get(svc);

      const _showError = (msg) => {
        const appAlert = _getService('appAlert');
        if (appAlert) {
          appAlert.error(msg);
        } else {
          $window.alert(msg);
        }
      };

      $rootScope.$on(
        '$stateChangeError',
        function (event, toState, toParams, fromState, fromParams, error) {
          event.preventDefault();
          if (error) {
            if (error.redirectTo) {
              return $timeout(() =>
                $state.go(
                  error.redirectTo.state,
                  error.redirectTo.params,
                  error.redirectTo.options,
                ),
              );
            } else if (
              error.data &&
              error.data.maintenanceMode === true &&
              $injector.has('productMaintenanceService')
            ) {
              return $injector.get('productMaintenanceService').goToError();
            } else if (error.status === 401) {
              $window.name = 'Q_LOGGED_OUT!' + $window.name;
              $window.location.reload();
              return;
            } else if (
              stateLoaded &&
              NETWORK_ERROR_CODES.includes(error.status)
            ) {
              let msg =
                'There appears to be an issue communicating with the server.';
              if (error.status < 500) {
                msg += ' Please check your network connection and try again.';
              } else {
                msg += ' Please wait a moment and try again.';
              }
              if (error.status > -1) {
                msg += ' (' + error.status;
                if (error.statusText) {
                  msg += ': ' + error.statusText;
                }
                msg += ')';
              }
              _showError(msg);
              // stay on the current route
              return;
            }
          }
          return $state.go('error', {
            toState,
            toParams,
            fromState,
            fromParams,
            error,
          });
        },
      );

      $rootScope.$on(
        '$stateNotFoundError',
        function (event, unfoundState, fromState, fromParams) {
          event.preventDefault();
          let toState = { name: unfoundState.to };
          return $state.go('error', {
            toState,
            toParams: unfoundState.toParams,
            fromState,
            fromParams,
            error: `State Not Found: ${toState.name}`,
          });
        },
      );
    },
  );
